'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.throwException = throwException;
exports.clearException = clearException;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var THROW = 'exception/THROW';
var CLEAR = 'exception/CLEAR';

var initialState = {
  errors: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case THROW:
      console.error(action);
      return (0, _extends3.default)({}, state, {
        errors: action.errors
      });
    case CLEAR:
      return (0, _extends3.default)({}, state, {
        errors: []
      });
    default:
      return state;
  }
}

function throwException() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return {
    type: THROW,
    errors: errors
  };
}

function clearException() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/exception.js
// module id = 97
// module chunks = 0